// extracted by mini-css-extract-plugin
module.exports = {"pintxo-illustration":"Illustration_pintxo-illustration__y1th8"};